export const APP_SET_TIMEZONE_DATA = 'APP_SET_TIMEZONE_DATA';
export const APP_SET_TIMEZONE_LOADING = 'APP_SET_TIMEZONE_LOADING';
export const APP_SET_SIDEBAR = 'APP_SET_SIDEBAR';
export const APP_SET_STICKY_FILTERS = 'APP_SET_STICKY_FILTERS';
export const APP_SET_FILTERS_TOGGLE_METHOD = 'APP_SET_FILTERS_TOGGLE_METHOD';
